import { ETierName, IKycDetailsApiDto, KycDocumentApprovalStatus } from './api'

const isKycVerificationSuccess = (kycDetails: IKycDetailsApiDto): boolean => {
    if (!kycDetails) return false
    const { out_of_limit, is_verified, limits_message } = kycDetails

    // @ts-ignore
    return (!out_of_limit || limits_message?.tier?.name === ETierName.Tier3) && is_verified
}

const requiresAdditionalKycDetails = (kycDetails: IKycDetailsApiDto): boolean => {
    if (!kycDetails) return false
    const { out_of_limit} = kycDetails
    return out_of_limit
}


// Basic documents verification means higher then Tier 0
const isBasicDocumentsVerified = (
    kycDetails: IKycDetailsApiDto
): boolean => kycDetails?.is_verified || kycDetails.id_document_status == KycDocumentApprovalStatus.APPROVED

export { isKycVerificationSuccess, isBasicDocumentsVerified, requiresAdditionalKycDetails }
